import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg transition-transform duration-300 group-hover:scale-110">
              <i className="ri-book-read-line text-background-50 text-lg"></i>
            </div>
            <span
              className={`font-heading text-xl font-bold transition-colors duration-300 ${
                scrolled ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              韩漫免费阅读
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                isActive('/')
                  ? 'bg-primary-500 text-background-50'
                  : scrolled
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  isActive(`/category/${cat.slug}`)
                    ? 'bg-primary-500 text-background-50'
                    : scrolled
                      ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
                      : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                isActive('/about')
                  ? 'bg-primary-500 text-background-50'
                  : scrolled
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled ? 'text-foreground-950 hover:bg-background-200' : 'text-background-50 hover:bg-background-50/10'
            }`}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className={`px-4 py-3 rounded-lg text-sm font-medium ${isActive('/') ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'}`}>首页</Link>
            {categories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className={`px-4 py-3 rounded-lg text-sm font-medium ${isActive(`/category/${cat.slug}`) ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'}`}>{cat.name}</Link>
            ))}
            <Link to="/about" className={`px-4 py-3 rounded-lg text-sm font-medium ${isActive('/about') ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'}`}>关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}